import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['greeting']

  connect() {
    this.setGreetingMessage();
  }

  setGreetingMessage() {
    if(this.hasGreetingTarget) {
      var currentHour = new Date().getHours();
      var greetings = $(this.greetingTarget).data('greetings')

      $(this.greetingTarget).html(`${this.timeOfDay(currentHour, greetings)}`);
    }
  }

  timeOfDay(hour, greetings) {
    var section = greetings.night;

    if (hour >= 0 && hour <= 11) {
      section = greetings.morning;
    } else if (hour >= 12 && hour <= 17) {
      section = greetings.afternoon;
    } else if (hour >= 18 && hour <= 23) {
      section = greetings.evening;
    }

    return section;
  }
}
